import { FC } from 'react';
// Import Helpers
import { injectContentUrl } from 'services/Helpers';
// Import Styles
import styles from './MarkDownReader.module.scss';

interface Props {
    src?: string;
    alt?: string;
    title?: string;
    onPreview: (src: string) => void;
}

/**
 * Renders a Markdown image with an optional size hint and click-to-preview.
 * Size convention: ![alt](url#w=240&h=120) — the hash is never sent to the
 * server; it is stripped here and applied as width/height.
 * The `--ContentUrl--` placeholder in the URL is replaced with the domain URL.
 */
const MDImage: FC<Props> = ({ src, alt, title, onPreview }) => {
    const [rawSrc, hash = ''] = String(src).split('#');
    // react-markdown percent-encodes the braces in the URL, so restore them
    // before swapping the {ContentUrl} placeholder for the real domain.
    const cleanSrc = injectContentUrl(rawSrc, '--ContentUrl--');
    const params = new URLSearchParams(hash);
    const width = params.get('w') ?? undefined;
    const height = params.get('h') ?? undefined;

    return (
        <img
            src={cleanSrc}
            alt={alt}
            title={title}
            width={width}
            height={height}
            className={styles.previewImg}
            onClick={() => onPreview(cleanSrc)}
        />
    );
};

export default MDImage;
